module.exports = __webpack_public_path__ + "img/img5.3a8c86de.png";